import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  root: {
    flexGrow: 1,
    maxWidth: 400,
    '&:focus, &:selected': {
      backgroundColor: 'transparent',
    },
  },
  classRowSuccess: {
    backgroundColor: '#e6f4ea',
  },
  classRowFail: {
    backgroundColor: '#ffe6e6',
  },
  labelRoot: {
    display: 'flex',
    alignItems: 'center',
  },
  labelIcon: {
    marginRight: theme.spacing(1),
    display: 'flex',
    padding: '0px',
  },
  labelText: {
    fontWeight: 'inherit',
    flexGrow: 1,
  },
  content: {
    marginTop: theme.spacing(5),
  },
  radioGroup: {
    marginLeft: theme.spacing(2),
  },
  metricsContent: {
    display: 'flex',
    justifyContent: 'flexStart',
    alignItems: 'center',
    flexDirection: 'column',
    color: '#FFF7FF',
    fontWeight: 'bold',
    height: theme.spacing(20),
    border: '1px solid #ffffff',
  },
  colorBlockA: {
    backgroundColor: '#19739d',
  },
  colorBlockB: {
    backgroundColor: '#1f93c6',
  },
  metricsContainer: {
    flexWrap: 'wrap',
    display: 'flex',
    width: 'auto',
    '& > *': {
      margin: theme.spacing(0),
      width: theme.spacing(30),
      height: theme.spacing(20),
    },
  },
});
